import types from '../types';

const teamApp = (
  state = { loading: false, data: null, error: null },
  action
) => {
  switch (action.type) {
    case types.GET_TEAM_APP_START:
      return { ...state, loading: true, error: null };
    case types.GET_TEAM_APP_SUCCESS:
      return { loading: false, error: null, data: action.payload };
    case types.GET_TEAM_APP_ERROR:
      return { loading: false, data: null, error: action.payload };
    case types.CLEAR_TEAM_APP:
      return { loading: false, data: null, error: null };

    default:
      return state;
  }
};

export default teamApp;
